import {useLocation} from 'react-router-dom';

import {Routes} from 'constants/routes';
import {useTranslation} from 'react-i18next';

export enum DrillingCarpetTabs {
    CALENDAR_SCHEDULER = 'calendar-scheduler',
    BUILDING_PLANNING = 'building-planning',
    DRILLING_SCHEDULER = 'drilling-scheduler',
    TEMPLATES = 'templates',
}

export const useTabsDrillingCarpet = () => {
    const location = useLocation();
    const {t} = useTranslation('drillingCarpet');

    const tabs = [
        {
            key: DrillingCarpetTabs.CALENDAR_SCHEDULER,
            label: t('tabs.calendarScheduler'),
            url: `${Routes.DrillingCarpet}/${DrillingCarpetTabs.CALENDAR_SCHEDULER}`,
        },
        {
            key: DrillingCarpetTabs.BUILDING_PLANNING,
            label: t('tabs.buildingPlanning'),
            url: `${Routes.DrillingCarpet}/${DrillingCarpetTabs.BUILDING_PLANNING}`,
        },
        {
            key: DrillingCarpetTabs.DRILLING_SCHEDULER,
            label: t('tabs.drillingScheduler'),
            url: `${Routes.DrillingCarpet}/${DrillingCarpetTabs.DRILLING_SCHEDULER}`,
        },
        {
            key: DrillingCarpetTabs.TEMPLATES,
            label: t('tabs.templates'),
            url: `${Routes.DrillingCarpet}/${DrillingCarpetTabs.TEMPLATES}`,
        },
    ];

    return {tabs, currentValue: location.pathname};
};
